module.exports = __webpack_public_path__ + "static/img/production3.f36a62c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/production3.png
// module id = XrYu
// module chunks = 2